<template>
	<div class="summary">
		<h2 class="title">Summary</h2>
		<dl>
			<dt>{{ config.product.name }}</dt>
			<dd>{{ formatPrice(config.product.price) }}</dd>
			<template v-for="(value, index) in summaryItems">
				<dt :key="index">{{ value.name }}</dt>
				<dd :key="index + '_val'">{{ formatPrice(value.price || 0) }}</dd>
			</template>
		</dl>
		<dl class="subtotal">
			<dt>Subtotal</dt>
			<dd>{{ subtotal }}</dd>
		</dl>
	</div>
</template>

<script>
import { mapState } from "vuex";
import helper from "@/mixins/helper.js";

export default {
	name: "Summary",
	mixins: [helper],
	computed: {
		...mapState({
			config: state => state.configurator.config,
			selectedOptions: state => state.configurator.selectedOptions,
			quantity: state => state.configurator.quantity
		}),
		summaryItems: function() {
			return Object.values(this.selectedOptions).sort((a, b) => (a.position > b.position ? 1 : -1));
		},
		subtotal: function() {
			return this.formatPrice(this.$store.getters["configurator/subtotal"]);
		},
		grandTotal: function() {
			return this.formatPrice(this.$store.getters["configurator/subtotal"] * (this.quantity || 1));
		}
	}
};
</script>

<style lang="scss" scoped>
.summary {
	margin-top: 16px;
	background: #f5f4f0;
	color: #454545;
	padding: 16px;

	.title {
		margin: 8px 0 16px 0;
	}

	> dl {
		display: flex;
		flex-wrap: wrap;

		> dt {
			width: 60%;
			padding-right: 4px;
			margin: 0 0 8px;
		}
		> dd {
			width: 40%;
			min-width: 80px;
			padding-left: 4px;
			margin: 0 0 8px;
			text-align: right;
		}
	}

	.subtotal,
	.grandTotal {
		border-top: 1px dashed #454545;
		padding-top: 8px;
		margin-top: 8px;
		margin-bottom: 0;
		font-weight: bold;
		text-align: right;
		font-size: 1.4em;

		> dt {
			text-align: left;
		}
	}
}
</style>